module.exports = __webpack_public_path__ + "static/img/homeNavigation2.8b4d163d.png";